import React, { useState, useEffect } from 'react'
import { MenuItem, Typography } from '@material-ui/core'
import { SelectFormsy } from '@fuse'
import { useIntl } from 'react-intl'
import effects from 'app/effects/effects'

export default (props) => {
  const {
    value,
    name,
    countryId,
    styleClass,
    regionType,
    updateCustomAddressFieldData,
    parentId,
    parentMethod,
    isLocal,
  } = props

  const { formatMessage } = useIntl()
  const regionTypes = {
    none: '',
    province: formatMessage({ id: 'crm.form.stateType.province' }),
    state: formatMessage({ id: 'crm.form.stateType.state' }),
    island: formatMessage({ id: 'crm.form.stateType.island' }),
    area: formatMessage({ id: 'crm.form.stateType.area' }),
    parish: formatMessage({ id: 'crm.form.stateType.parish' }),
    perfecture: formatMessage({ id: 'crm.form.stateType.perfecture' }),
    district: formatMessage({ id: 'crm.form.stateType.district' }),
    department: formatMessage({ id: 'crm.form.stateType.department' }),
    oblast: formatMessage({ id: 'crm.form.stateType.oblast' }),
    emirate: formatMessage({ id: 'crm.form.stateType.emirate' }),
  }

  let initLocalState = {
    states: [],
    labelName: '',
    value,
  }
  const [localState, setLocalState] = useState(initLocalState)
  const initCountryId = countryId
  const ref = React.useRef(null)
  useEffect(() => {
    setLocalState(initLocalState)
    if (countryId) {
      effects.apis.getStatesByCountryId({ countryId }).then((states) => {
        let newState = {
          ...localState,
          states: states.data,
          labelName: regionTypes[regionType],
        }
        if (initCountryId !== countryId) {
          newState['value'] = null
        }
        setLocalState(newState)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryId, regionType])

  return localState.labelName ? (
    <div className={styleClass.formRow}>
      <div className={styleClass.formRowIcon} />
      <div className={styleClass.formRowInputs}>
        <div className={styleClass.formRowItemTwo}>
          <SelectFormsy
            className="w-full"
            name={name}
            label={localState.labelName}
            value={localState.value}
            variant="standard"
          >
            {localState.states.map((item) => {
              return (
                <MenuItem
                  key={item.id}
                  value={item.id}
                  data-value={item.id}
                  ref={ref}
                  onClick={() =>
                    updateCustomAddressFieldData &&
                    updateCustomAddressFieldData({
                      currentValue: item.id,
                      addressDataId: parentId,
                      labelName: 'Province',
                      labelMethod: parentMethod,
                      isLocal: isLocal,
                      countryCode: undefined,
                      countryId: countryId,
                      regionType: regionType,
                    })
                  }
                >
                  <Typography>{item.name}</Typography>
                </MenuItem>
              )
            })}
          </SelectFormsy>
        </div>
      </div>
    </div>
  ) : (
    ''
  )
}
